import { benefits } from "@/mocks/content";

export default function BenefitsSection() {
  return (
    <section className="py-16 md:py-20 bg-background-100">
      <div className="max-w-6xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block px-3 py-1 rounded-full bg-secondary-100 text-secondary-700 text-xs font-semibold tracking-wide uppercase mb-4">
            Why Vigorbuy Spreadsheet
          </span>
          <h2 className="text-3xl md:text-4xl font-heading font-bold text-foreground-950">
            Stop Wasting Hours Searching Products
          </h2>
          <p className="text-foreground-600 mt-3 max-w-2xl mx-auto text-sm md:text-base">
            Finding reliable products can be difficult. Our Vigorbuy Spreadsheet helps you discover curated finds, compare products, understand shipping, and buy more confidently.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {benefits.map((item, idx) => (
            <div
              key={idx}
              className="bg-background-50 rounded-xl p-5 md:p-6 border border-background-200/60 hover:border-accent-200/50 transition-colors"
            >
              <div className="w-10 h-10 rounded-lg bg-accent-100 flex items-center justify-center mb-4">
                <i className={`${item.icon} text-accent-600 text-lg w-5 h-5 flex items-center justify-center`}></i>
              </div>
              <h3 className="text-base md:text-lg font-semibold text-foreground-950 mb-2">
                {item.title}
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed">
                {item.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}